function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './EventHeader.css';
import React, { useState, Fragment, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import { differenceInDays } from 'date-fns';
import { canUseDOM, get, getGlobalDictionaryTerm, getLangPrefixLink } from '../../utils';
import StickyCtaAssistant from '../../utils/StickyCtaAssistant';
import Reminder from '../atoms/Reminder/Reminder';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import makeUrls from './makeUrls';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
/* import AddToCalendar, { DropdownOuter } from './AddToCalendar'; */
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import closeWhite from '../../resources/icons/close-white.svg';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as ChevronRightLight } from '../../resources/icons/chevron-right-light.svg';
import { ReactComponent as LocationBlue } from '../../resources/icons/location-grey.svg';
import { ReactComponent as Ticket } from '../../resources/icons/ticket-grey.svg';
import { ReactComponent as ReminderIcon } from '../../resources/icons/icon-reminder.svg';
import { ReactComponent as IconClose } from '../../resources/icons/close.svg';
import { ReactComponent as PlusIcon } from '../../resources/icons/icon-plus-round.svg';
import { ReactComponent as MinusIcon } from '../../resources/icons/icon-minus-round.svg';
import { ReactComponent as EmailBigIcon } from '../../resources/icons/email-large.svg';
import { ReactComponent as CalendarBigIcon } from '../../resources/icons/calendar-large.svg';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
import arrowLeftnoborderWhite from '../../resources/icons/arrow-left-noborder-white.svg';
import RouterLink from '../atoms/RouterLink';
import { Scrollbars } from 'react-custom-scrollbars-2';
// import GoogleMap, { defaultMapState } from '../atoms/GoogleMaps/GoogleMaps';
// import getPlaceInfoByID from '../atoms/GoogleMaps/GooglePlaceService';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import ChevronUp from '../atoms/Icons/IconChevronUp';
import { tealiumClickFunc, tealiumMergeClickData, tealiumClickFuncExtended } from '../../utils/tealium';
// import loadable from '@loadable/component';
import EventPopup from './EventPopup';
import { getLatestUserCookie } from '../Login/user_session';
import { convertToAnalyticObject } from '../../utils/analytics';
import useProfile from '../../utils/hooks/useProfile';
import { hexToRgb } from '../../utils/hexToRgb';
import useHasClass from '../../utils/hooks/useHasClass';

// const Scrollbars = loadable(() => import('react-custom-scrollbars'), { ssr: false });

const createRouterLink = (buyLink, accessToken, venueWebsite, isTicketing) => {
  if (buyLink) {
    return isTicketing ? accessToken ? buyLink + accessToken : `/login?redirect_url=${buyLink}` : buyLink;
  } else {
    return venueWebsite;
  }
};
const reminderAccordionInitialState = {
  visible: false,
  visibleArea: 'email',
  isEmailBlockHidden: false
};
const calendarReminderInitialState = {
  visible: false,
  selectedString: '',
  value: ''
};
export const EventHeader = _ref => {
  let {
    fields,
    rendering,
    children,
    params,
    route
  } = _ref;
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const [activateEvents, setactivateEvents] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [currentUrls, setCurrentUrls] = useState({
    google: '',
    outlook: '',
    yahoo: '',
    ics: ''
  });
  const [isChina, setIsChina] = React.useState(false);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const currentLang = get(sitecoreContext, 'language');
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const userProfile = useProfile();
  const moduleId = get(fields, 'data.item.id');
  const eventArchived = get(route, 'fields.Archived.value');
  const isTicketing = get(route, 'fields.Is Ticketing.value');
  const theme = get(sitecoreContext, 'themesOfPage');
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
  const setReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSetReminder') || 'Set reminder';
  const editLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEdit') || 'Edit';
  const emailReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmailReminder') || 'Email reminder';
  const calendarReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderCalendarReminder') || 'Calendar reminder';
  const accordeonIntroLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmailReminderText') || 'An email will be sent to your inbox as a reminder';
  const selectMediaLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSelect') || 'Select';
  const ReminderGoogle = getGlobalDictionaryTerm(sitecoreContext, 'ReminderGoogle') || 'ReminderGoogle';
  const ReminderOutlookWebApp = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOutlookWebApp') || 'ReminderOutlookWebApp';
  const ReminderOutlook = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOutlook') || 'ReminderOutlook';
  const ReminderYahoo = getGlobalDictionaryTerm(sitecoreContext, 'ReminderYahoo') || 'ReminderYahoo';
  const CloseRemonderAccordeon = getGlobalDictionaryTerm(sitecoreContext, 'close') || 'close';
  const serverRole = get(sitecoreContext, 'configuration.serverRole');
  const eventTags = get(fields.data.item.tags, 'targetItems', []);
  const notContainBusinessEventTag = !eventTags.some(tag => tag.name === 'Business event');
  const [hideEvents, sethideEvents] = useState(rtl);
  const primaryCtaLinkLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const primaryCtaLinkRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  const scrollRef = /*#__PURE__*/React.createRef();
  const buttonRef = /*#__PURE__*/React.createRef();
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary') || '#035E88';
  const z200Display = useHasClass('html', 'z200');
  const z150Display = useHasClass('html', 'z150');
  const colorVariables = {
    '--main-color-opacity': hexToRgb(primaryPageThemeColor).concat(', 0.1')
  };
  // const medias: any = get(ListicleMedia, 'fields.data.item.mediaItems');
  const placeholdersItems = get(rendering, 'placeholders.media-header-general') || [];
  const eventDateString = get(fields, 'data.item.eventDates.jss.value');
  const eventDates = Boolean(eventDateString) && JSON.parse(eventDateString).dates || [];
  const currentDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString();
  let dateStart = '';
  let dateEnd = '';
  const validEvents = eventDates.filter(arr => {
    const stDate = String(get(arr, 'Date')) || '';
    const edDate = String(get(arr, 'DateTo', ''));
    const edDateValid = edDate ? edDate : stDate;
    if (stDate && !dateStart) {
      dateStart = stDate;
    }
    if (edDate && !dateEnd) {
      dateEnd = edDate;
    }
    if (stDate >= currentDate || edDateValid >= currentDate) {
      return arr;
    }
  });
  const setDateFormat = (date, enFormat) => {
    return new Date(date).toLocaleDateString(currentLang === 'en' || enFormat ? 'en-GB' : currentLang, {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      numberingSystem: 'latn'
    });
  };
  const dateAnalytics = `${dateStart ? setDateFormat(dateStart, true) : ''}${dateStart && dateEnd ? ' - ' : ''}${dateEnd ? setDateFormat(dateEnd, true) : ''}`;
  const curatorString = get(fields, 'data.item.curators.jss.value');
  const curators = Boolean(curatorString) && JSON.parse(curatorString).curators;
  const introText = get(fields, 'data.item.introText.jss');
  const defaultAddress = get(fields, 'data.item.address.jss.value');
  const title = get(fields, 'data.item.title.jss');
  const titleForAnalytics = get(fields, 'data.item.titleAnalytics.jss');
  const tagName = get(fields, 'data.item.tag.targetItem.title.jss.value');
  const tagNameForAnalytics = get(fields, 'data.item.tag.targetItem.titleAnalytics.jss.value');
  const buyLink = get(fields, 'data.item.buyLink.jss.value.href');
  const buyLinkMobile = get(fields, 'data.item.buyLinkMobile.jss.value.href');
  const name = get(fields, 'data.item.name');
  const hasGooglePlaceIDCollection = Boolean(get(fields, 'data.item.googlePlaceIDCollection.googlePlaceIds.length'));
  const googleMapUrl = 'https://www.google.com/maps/place/?q=place_id:';
  const googlePlaceIDCollection = hasGooglePlaceIDCollection ? get(fields, 'data.item.googlePlaceIDCollection.googlePlaceIds') : [];
  const placeIDfallback = get(googlePlaceIDCollection[0], 'name', '');
  const address = get(fields, 'data.item.address.jss', '');
  const parentEventLogo = get(fields, 'data.item.parentEvent.targetItem.logo.src');
  const parentEventLogoLink = get(fields, 'data.item.parentEvent.targetItem.url');
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  const hasVenues = Boolean(get(fields, 'data.item.venue.values.length'));
  const [venue] = hasVenues ? get(fields, 'data.item.venue.values') : [];
  const venueValues = hasVenues ? get(fields, 'data.item.venue.values') : [];
  const ticketPrice = get(fields, 'data.item.ticketPrice.jss.value', '');
  const isFree = Boolean(get(fields, 'data.item.isFree.boolValue'));
  const ticketsAvailable = get(fields, 'data.item.ticketsAvailable.jss.value');
  const minPrice = get(fields, 'data.item.minPrice.jss.value', '');
  const maxPrice = get(fields, 'data.item.maxPrice.jss.value', '');
  const venueWebsite = get(fields, 'data.item.website.jss.value.href', '');
  const tickets = get(fields, 'data.item.tickets', []);
  const [ticketsDdVisible, setTicketsDdVisible] = useState(false);
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const [reminderAccordionState, setReminderAccordionState] = useState(reminderAccordionInitialState);
  const [calendarReminderState, setCalendarReminderState] = useState(calendarReminderInitialState);
  const [eventForReminder, setEventForReminder] = useState({});
  const carouselBlockRef = React.useRef(null);
  const dictionaryForCurators = get(fields, 'data.dictionary.dictionaryValues') || [];
  const dictionary = (get(fields, 'data.dictionary.dictionaryValues') || []).concat(dictionaryForCurators);
  const dictionaries = Boolean(dictionary) && dictionary.reduce((aggregator, currentValue) => aggregator.set(currentValue.key.jss && currentValue.key.jss.value, currentValue.phrase.jss && currentValue.phrase.jss.value), new Map());
  const imagesAndVideos = [];
  const singleVenueAddress = get(venueValues[0], 'title.jss.value');
  const singleVenuePlaceID = get(venueValues[0], 'googlePlaceID.jss.value');
  const placeInfoRef = React.useRef(null);
  // const [mapState, setMapState] = React.useState(defaultMapState);
  const [locationIcon, setLocationIcon] = React.useState('');
  // const [placeID, setPlaceID] = React.useState<string>('');
  const [showLocationIcon, setShowLocationIcon] = React.useState(true);

  // const apiReady = () => {
  //   const googlePlaceID: string = placeIDfallback ? placeIDfallback : singleVenuePlaceID; //dubai place id
  //
  //   if (googlePlaceID) {
  //     // setShowLocationIcon(false);
  //     getPlaceInfoByID(googlePlaceID, placeInfoRef.current, (place: any) => {
  //       const locationPlaceID = get(place, 'formatted_address');
  //       setPlaceID(locationPlaceID);

  //     });
  //   }
  // };

  useEffect(() => {
    getLatestUserCookie(identityGlobal, clientId, clientSecret).then(value => {
      let userCookie = value;
      if (userCookie && userCookie.login_status) {
        if (userCookie.access_token) {
          setAccessToken(`&dtcm_access_token=${userCookie.access_token}`);
        }
      }
    });
  }, []);
  const updateHeight = () => {
    if (carouselBlockRef.current) {
      const height = carouselBlockRef.current.offsetHeight;
      carouselBlockRef.current.style.setProperty('--carousel-item-height', `${height < 571 ? 570 : height}px`);
    }
  };
  useEffect(() => {
    if (isSharedCh) {
      updateHeight();
      window.addEventListener('resize', updateHeight);
      return () => {
        window.removeEventListener('resize', updateHeight);
      };
    }
  }, [isSharedCh]);
  useEffect(() => {
    if (canUseDOM && (z200Display || z150Display)) {
      updateHeight();
    }
  }, [z200Display, z150Display]);
  const [isOpenReminderCalendarPicker, setIsOpenReminderCalendarPicker] = useState(false);
  const eventObjForReminder = useMemo(() => {
    const imageSet = !!placeholdersItems.length;
    const imageField = imageSet ? get(placeholdersItems[0], 'fields.data.item') : '';
    let eventImage = !!imageField || '';
    if (imageField) {
      const imagesArray = get(imageField, 'children');
      if (imagesArray && imagesArray.length) {
        eventImage = get(imagesArray[0], 'image.jss.value.src');
      } else {
        eventImage = get(imageField, 'image.jss.value.src');
      }
    }
    return {
      objectID: moduleId,
      title: title && title.value,
      introText: introText && introText.value,
      location: address && address.value,
      url: canUseDOM ? window.location.href : '',
      category: tagName,
      image: eventImage,
      type: ['Event']
    };
  }, []);
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const urlParams = new URLSearchParams(document.location.search);
      const isC = Boolean(urlParams.get('isChina') === 'true');
      setIsChina(isC);
    }
  }, []);
  const {
    addToCalendarClickAnalytics,
    buyTicketsClickAnalytics,
    addToFavAnalytics,
    locationAnalytics,
    seeAllDatesClickAnalytics,
    sliderAnalytics,
    buyMultipleTicketsClickAnalytics,
    buyNowMultipleTicketsClickAnalytics
  } = fields.data;
  const eAnalytics = get(fields, 'data.eventsAnalytics');
  let eventsAnalytics;
  if (eAnalytics) {
    eventsAnalytics = convertToAnalyticObject(eAnalytics);
  }
  const getMonth = date => {
    return new Date(date).getMonth();
  };
  const getMonthAndYear = date => {
    const month = new Date(date).getMonth();
    const year = new Date(date).getFullYear();
    return `${month},${year}`;
  };
  const monthsFull = new Array();
  for (let i = 1; i <= 12; i++) {
    const month = new Date(`1999/${i}/1`).toLocaleDateString(currentLang, {
      month: 'long'
    });
    monthsFull.push(month);
  }
  const monthsShort = new Array();
  for (let i = 1; i <= 12; i++) {
    const month = new Date(`1999/${i}/1`).toLocaleDateString(currentLang === 'en' ? 'en-GB' : currentLang, {
      month: 'short'
    });
    monthsShort.push(month);
  }
  const renderLogo = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "dubai-calendar-logo"
    }, theme && theme.dubai_calendar_logo && /*#__PURE__*/React.createElement("img", {
      className: "header-events__title-img header-events__title-imgTheme",
      src: BASE_URL + theme.dubai_calendar_logo + '?cx=0.5&cy=0.5&cw=150',
      alt: "Logo"
    }), parentEventLogo && (parentEventLogoLink ? /*#__PURE__*/React.createElement("a", {
      href: parentEventLogoLink,
      "aria-label": "Logo",
      "aria-labelledby": "Logo"
    }, /*#__PURE__*/React.createElement("img", {
      className: "header-events__title-img",
      src: BASE_URL + parentEventLogo + '?cx=0.5&cy=0.5&cw=150&ch=150',
      alt: "Logo"
    })) : /*#__PURE__*/React.createElement("img", {
      className: "header-events__title-img",
      src: BASE_URL + parentEventLogo + '?cx=0.5&cy=0.5&cw=150&ch=150',
      alt: "Logo"
    }))));
  };
  const renderCurators = () => {
    if (!curators) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "curators-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "curators__block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "curators__row"
    }, curators && curators.map(curator => /*#__PURE__*/React.createElement("img", {
      className: "curators__image-item",
      src: `${curator.Image && curator.Image.includes(BASE_URL) ? '' : BASE_URL}${curator.Image}&cw=22&ch=22`,
      alt: curator.Name
    }))), /*#__PURE__*/React.createElement("div", {
      className: "curators__author"
    }, dictionaries.get('CuratorsPick'))), renderLogo());
  };
  const renderPriceBlock = () => {
    if (isFree) {
      return dictionaries.get('FreeEvent');
    }
    if (rtl) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && !minPrice && !minPrice && ticketPrice ? /*#__PURE__*/React.createElement(React.Fragment, null, ticketPrice) : /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && ticketsAvailable && (minPrice || minPrice) ? dictionaries.get('TicketsAvailableFrom') : dictionaries.get('TicketPriceFrom'), !isFree && (minPrice || minPrice) && ' ' + minPrice + ' ' + dictionaries.get('AED'), !isFree && minPrice ? `${maxPrice ? ' - ' + maxPrice + ' ' + dictionaries.get('AED') : ''}` : `${minPrice ? ' - ' + minPrice : ' - ' + ticketPrice} `));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && !minPrice && !minPrice && ticketPrice ? /*#__PURE__*/React.createElement(React.Fragment, null, ticketPrice) : /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && ticketsAvailable && (minPrice || minPrice) ? dictionaries.get('TicketsAvailableFrom') : dictionaries.get('TicketPriceFrom'), !isFree && (minPrice || minPrice) && ' ' + dictionaries.get('AED') + ' ', !isFree && minPrice ? `${minPrice} ${maxPrice ? ' - ' + dictionaries.get('AED') + ' ' + maxPrice : ''}` : `${minPrice ? minPrice : ticketPrice} `));
    }
  };
  const showEvents = e => {
    e.preventDefault();
    setactivateEvents('show-events');
  };
  const closeEvents = e => {
    e.preventDefault();
    setactivateEvents('');
  };
  /* eslint-disable  */
  const renderItems = () => {
    if (placeholdersItems) {
      return placeholdersItems.map(item => {
        const imageSrc = get(item, 'fields.data.item.image.jss.value.src');
        const imageAlt = get(item, 'fields.data.item.image.jss.value.alt');
        return /*#__PURE__*/React.createElement(LazyPicture, {
          className: "styled-curved-image",
          useEmptyPlaceholder: true
        }, /*#__PURE__*/React.createElement("source", {
          media: "(min-width:769px)",
          srcSet: `${BASE_URL + imageSrc}&cw=795&ch=595`
        }), /*#__PURE__*/React.createElement("img", {
          src: `${BASE_URL + imageSrc}&cw=795&ch=595`,
          alt: imageAlt
        }));
      });
    }
    return [];
  };
  /* eslint-enable  */
  const getDate = date => {
    const day = new Date(date).getDate();
    return !Number.isNaN(day) && day < 10 ? '0' + day.toString() : day.toString();
  };
  const getYear = date => {
    return new Date(date).getFullYear();
  };
  const renderListDate = () => {
    const dateRanges = [];
    validEvents.forEach(date => {
      if (dateRanges.some(el => getMonthAndYear(el.key) === getMonthAndYear(date.Date))) {
        dateRanges.find(el => getMonthAndYear(el.key) === getMonthAndYear(date.Date)).values.push(date);
      } else {
        dateRanges.push({
          key: date.Date,
          values: [date]
        });
      }
    });
    if (!dateRanges) {
      return null;
    }
    return dateRanges && dateRanges.map((date, index) => {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "events-overlay__month-n-year"
      }, `${monthsFull[Number(getMonth(date.key))]} ${getYear(date.key)}`), renderEventDates(undefined, date.values, venue));
    });
  };
  const renderEventDates = (eventNumbers, eventD, venue) => {
    if (!eventD) {
      return null;
    }
    //Commented code below can be deleted after S26 || september 2024
    // const isDateDisable = (start: Date) => {
    //   const lastPossibleDateForOneReminder = new Date(start);
    //   lastPossibleDateForOneReminder.setDate((new Date(start)).getDate());
    //   const reminder1Stamp = lastPossibleDateForOneReminder.getTime();
    //   const nowStamp = Date.now();
    //   return nowStamp > reminder1Stamp;
    // }

    const venueTitle = get(title, 'value');
    const venueDetails = get(introText, 'value');
    const venueAddress = get(venue, 'address.jss.value');
    const numberOfItemsToRender = eventNumbers;
    return eventD && eventD.slice(0, numberOfItemsToRender).map((date, index) => {
      const eventDate = get(date, 'Date') || '';
      const eventDateTo = get(date, 'DateTo') || '';
      const eventTimeStartCheck = get(date, 'TimeStart');
      const eventTimeEndCheck = get(date, 'TimeEnd');
      const eventTimeStart = get(date, 'TimeStart') || '00:00:00';
      const [eventDateFull, eventDateToFull] = generateDateForCalendar(date);
      /* Event Dates End*/
      /* const reminderButtonDisabled = isDateDisable(new Date(`${eventDate} ${eventTimeStart}`)); */

      //  this line no longer needed because of new logic and can be deleted after S26 || september 2024)
      const numberOfDaysBeforeEventEnd = differenceInDays(new Date(eventDateTo !== '' ? eventDateTo : eventDate), currentDateFormatted);
      const numberOfDaysBeforeEventStart = differenceInDays(new Date(eventDate && eventDate), currentDateFormatted);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "header-event-list",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__date"
      }, eventDate >= currentDate, eventDate && getDate(eventDate), /*#__PURE__*/React.createElement("span", {
        className: "header-event-list__month"
      }, eventDate && monthsShort[Number(getMonth(eventDate))])), eventDateTo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "event-separator"
      }), /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__date"
      }, getDate(eventDateTo), /*#__PURE__*/React.createElement("span", {
        className: "header-event-list__month"
      }, eventDateTo && monthsShort[Number(getMonth(eventDateTo))]))), /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__complete-date"
      }, eventDate && setDateFormat(eventDate)), /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__days"
      }, eventTimeStartCheck && eventTimeStartCheck.substring(0, 5), eventTimeEndCheck && ' - ' + eventTimeEndCheck.substring(0, 5)), (eventDate || eventDateTo) && notContainBusinessEventTag && /*#__PURE__*/React.createElement("button", {
        className: "reminder-accordion-opener btn--reset",
        disabled: numberOfDaysBeforeEventEnd <= 0,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderOpenClickAnalytics'], params), `${get(fields, 'data.item.title.jss.value', '')} : event detail`);
          setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
            visible: true
          }));
          setEventForReminder(_objectSpread(_objectSpread({}, eventObjForReminder), {}, {
            detailEventTimeStart: eventTimeStart,
            detailEventDateStart: eventDate,
            detailEventDateEnd: eventDateTo,
            numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd
          }));
          if (numberOfDaysBeforeEventEnd === 1 || numberOfDaysBeforeEventStart === 1) {
            setReminderAccordionState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
              visibleArea: 'calendar',
              isEmailBlockHidden: true
            }));
          } else {
            setReminderAccordionState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
              visibleArea: 'email',
              isEmailBlockHidden: false
            }));
          }
          const newUrls = makeUrls({
            name: `${venueTitle}`,
            details: `${venueDetails}`,
            location: `${venueAddress}`,
            startsAt: `${eventDateFull}`,
            endsAt: `${eventDateToFull ? eventDateToFull : eventDateFull}`
          });
          setCurrentUrls(newUrls);
        }
      }, /*#__PURE__*/React.createElement("span", null, isSharedCh ? /*#__PURE__*/React.createElement("svg", {
        className: "icon-calendar",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M13.3333 0H1.66667C0.741667 0 0 0.75 0 1.66667V13.3333C0 14.25 0.741667 15 1.66667 15H13.3333C14.25 15 15 14.25 15 13.3333V1.66667C15 0.75 14.25 0 13.3333 0ZM13.3333 13.3333H1.66667V1.66667H13.3333V13.3333ZM6.66667 11.6667H8.33333V8.33333H11.6667V6.66667H8.33333V3.33333H6.66667V6.66667H3.33333V8.33333H6.66667V11.6667Z",
        fill: "currentColor"
      })) : /*#__PURE__*/React.createElement(ReminderIcon, {
        className: "icon-calendar"
      }), ' ', setReminderLabel)))));
    });
  };
  /* eslint-disable  */

  const changeAccordeonArea = type => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailReminderInteractionAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), type, 'open']);
    setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
      visibleArea: type
    }));
  };

  /* eslint-enable  */

  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering
    });
  };
  const renderVariousLocationsLink = (locationAnalytics, params, name) => {
    return /*#__PURE__*/React.createElement("a", {
      href: "#overview",
      className: `info-box-list__content para ${isSharedCh ? 'info-box-list__content--link' : ''}`,
      "data-cy": "link-various",
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(locationAnalytics, params), name);
      }
    }, dictionaries.get('SeveralLocations'));
  };
  const renderPlaceIdLink = () => {
    setShowLocationIcon(false);
    return /*#__PURE__*/React.createElement(React.Fragment, null);
    // return (
    //   <a
    //     href={googleMapUrl + placeIDfallback}
    //     className="info-box-list__content para"
    //     target="_blank"
    //     rel="noopener noreferrer"
    //     data-cy="link-place-id"
    //   >
    //     {placeID as any}
    //   </a>
    // );
  };
  const renderVenuesLink = (locationAnalytics, params, name) => {
    const validPlaceId = placeIDfallback ? placeIDfallback : singleVenuePlaceID;
    const validVenueAddress = singleVenueAddress;
    if (!validVenueAddress) {
      setShowLocationIcon(false);
    }
    return /*#__PURE__*/React.createElement("a", {
      href: googleMapUrl + validPlaceId,
      "aria-label": `${validVenueAddress} | ${newWindowLabel}`,
      target: "_blank",
      rel: "noopener noreferrer",
      className: `info-box-list__content para ${isSharedCh ? 'info-box-list__content--link' : ''}`,
      "data-cy": "link-venues",
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(locationAnalytics, params), name);
      }
    }, validVenueAddress, isSharedCh && /*#__PURE__*/React.createElement("svg", {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M13.3333 13.3333H1.66667V1.66667H7.5V0H1.66667C0.741667 0 0 0.75 0 1.66667V13.3333C0 14.25 0.741667 15 1.66667 15H13.3333C14.25 15 15 14.25 15 13.3333V7.5H13.3333V13.3333ZM9.16667 0V1.66667H12.1583L3.96667 9.85833L5.14167 11.0333L13.3333 2.84167V5.83333H15V0H9.16667Z",
      fill: "currentColor"
    })));
  };
  const runExtendedAnalytics = eventName => {
    tealiumClickFuncExtended(tealiumMergeClickData(buyTicketsClickAnalytics, params), eventName, {
      whats_on_event_name: titleForAnalytics.value,
      event_venue: get(venue, 'addressAnalytics.jss.value'),
      event_date: dateAnalytics,
      event_type: tagNameForAnalytics
    });
  };
  const renderBuyButton = ticket => {
    const availableTickets = get(ticket, 'available.jss.value', false);
    const seller = ticket.ticketSeller.jss.value;
    const href = ticket.buyNowLink.jss.value.href;
    const priceRange = ticket.printPrice.jss.value;
    const titleOfShow = title ? title.value : '';
    const ctaText = availableTickets ? dictionaries.get('buyNow') || 'Buy now' : dictionaries.get('GoToEventDetailsWebsite') || 'More info';
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      className: "tickets-cta-dd__book",
      "aria-label": `${seller} | ${ctaText} | ${newWindowLabel}`,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(buyNowMultipleTicketsClickAnalytics, params), [titleOfShow, seller, priceRange]);
      }
    }, ctaText);
  };
  const eventDateRangeString = get(fields, 'data.item.eventDatesRange.jss.value', '');
  const eventDateRangeParsed = eventDateRangeString && JSON.parse(eventDateRangeString);
  const eventStartDate = eventDateRangeParsed && eventDateRangeParsed.dates && eventDateRangeParsed.dates[0];
  const eventEndDate = eventDateRangeParsed && eventDateRangeParsed.dates && eventDateRangeParsed.dates[1];
  let locationSchema = '';
  let locationaddressSchema = '';
  if (defaultAddress) {
    locationaddressSchema = defaultAddress;
    locationSchema = defaultAddress;
  } else if (googlePlaceIDCollection.length === 0 && venueValues.length === 1) {
    const singleVenueTitle = get(venueValues[0], 'title.jss.value');
    const singleVenueAddress = get(venueValues[0], 'address.jss.value');
    locationaddressSchema = singleVenueAddress;
    locationSchema = singleVenueTitle;
  } else {
    locationSchema = dictionaries.get('SeveralLocations');
    locationaddressSchema = dictionaries.get('SeveralLocations');
  }
  // Popup Code Start
  const [showPopup, setShowPopup] = useState(false);
  const redirectURL = get(fields, 'data.listingPageConfiguration.listingPage.jss.url', '');
  const secondsToRedirect = 5;
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  function dateDiffInDays(a, b) {
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }
  const generateDateForCalendar = date => {
    const eventDate = get(date, 'Date') || '';
    const eventDateTo = get(date, 'DateTo') || '';
    const eventTimeStart = get(date, 'TimeStart') || '00:00:00';
    const eventTimeEnd = get(date, 'TimeEnd') || '00:00:00';
    const eventDateFull = eventDate && eventDate.substring(0, 10) + 'T' + eventTimeStart.substring(0, 5) + '+04:00';
    const eventDateToFull = eventDateTo && eventDateTo.substring(0, 10) + 'T' + eventTimeEnd.substring(0, 5) + '+04:00';
    return [eventDateFull, eventDateToFull];
  };
  let hideDropdown, clickedOnAddToCalendar, ticketsBtnClickHandler, ticketsDdCloseHandler;
  if (canUseDOM) {
    /* hideDropdown = () => {
      setDropdownState({
        show: false,
        left: 0,
        top: 0,
      });
    }; */

    /* clickedOnAddToCalendar = (event: any) => {
      if (event.target.classList.contains('chq-atc--button') === true) {
        // if the attribute exists...
          const boundingBox = event.target.getBoundingClientRect();
        let left = boundingBox.left;
        if (document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
          left = boundingBox.right;
        }
        setDropdownState({
          show: true,
          left: left,
          top: boundingBox.top,
        });
      } else {
        hideDropdown();
      }
    }; */

    ticketsBtnClickHandler = () => {
      const titleOfShow = title ? title.value : '';
      if (!ticketsDdVisible) {
        setTicketsDdVisible(true);
        tealiumClickFunc(tealiumMergeClickData(buyMultipleTicketsClickAnalytics, params), [titleOfShow, `${minPrice || 0} - ${maxPrice || 0}`]);
        document.addEventListener('click', ticketsDdCloseHandler);
      }
    };
    ticketsDdCloseHandler = event => {
      if (!(event.target && event.target.closest('.tickets-cta-dd'))) {
        setTicketsDdVisible(false);
        document.removeEventListener('click', ticketsDdCloseHandler);
      }
    };
  }
  React.useEffect(() => {
    const endDate = new Date(eventEndDate);
    const dateToday = new Date();
    endDate.setHours(0, 0, 0, 0);
    dateToday.setHours(0, 0, 0, 0);
    const difference = dateDiffInDays(endDate, dateToday);
    const interval = 200;
    const maxCheck = 2400;
    let time = 0;
    let actionBtn = document.querySelectorAll('.scroll-action-btn')[0];
    if (canUseDOM && rtl) {
      const clear = setInterval(() => {
        if (scrollRef.current) {
          actionBtn.click();
          sethideEvents(false);
          clearInterval(clear);
        }
        if (time >= maxCheck && hideEvents) {
          actionBtn.click();
          sethideEvents(false);
          clearInterval(clear);
        }
        time += interval;
      }, interval);
    }
    if (eventArchived) {
      setShowPopup(true);
    }
    if (difference > 0) {
      setShowPopup(true);
    }
    if (difference > 30) {
      setTimeout(() => {
        if (!pageEditing && !serverRole.includes('ContentManagement')) {
          window.location.href = getLangPrefixLink(redirectURL, currentLang);
        }
      }, secondsToRedirect * 1000);
    }

    /* if (canUseDOM) {
      const clickedOnAddToCalendar = (event: any) => {
        if (event.target.classList.contains('chq-atc--button') === true) {
          // if the attribute exists...
            const boundingBox = event.target.getBoundingClientRect();
          let left = boundingBox.left;
          if (document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
            left = boundingBox.right;
          }
          setDropdownState({
            show: true,
            left: left,
            top: boundingBox.top,
          });
        } else {
          setDropdownState({
            show: false,
            left: 0,
            top: 0,
          });
        }
      };
        document.addEventListener('click', clickedOnAddToCalendar);
      window.addEventListener('scroll', hideDropdown);
      window.addEventListener('resize', hideDropdown);
    } */

    return () => {
      /* if (canUseDOM) {
        // unmounting all events
        document.removeEventListener('click', clickedOnAddToCalendar);
        window.removeEventListener('scroll', hideDropdown);
        window.removeEventListener('resize', hideDropdown);
      } */
    };
  }, []);
  React.useEffect(() => {
    return () => {
      if (canUseDOM) {
        // unmounting close dropdown handler
        document.removeEventListener('click', ticketsDdCloseHandler);
      }
    };
  }, []);

  // Popup Code End

  const [reminderQueryParamValue, setReminderQueryParamValue] = useState('');
  const [reminderPopupVisible, setReminderPopupVisible] = useState(false);
  useEffect(() => {
    if (canUseDOM && window.location.search) {
      const queryReminderParamValue = new URLSearchParams(window.location.search).get('reminder') || '';
      setReminderQueryParamValue(queryReminderParamValue);
      const queryParamEventStarted = new URLSearchParams(window.location.search).get('eventstarted') || '';
      setReminderPopupVisible(queryParamEventStarted === 'true' ? true : false);
    }
  }, []);
  useEffect(() => {
    if (validEvents.length === 1) {
      if (reminderQueryParamValue === '1' || reminderQueryParamValue === '2' || reminderPopupVisible) {
        setReminderAccordionState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          visible: true
        }));
        if (reminderQueryParamValue === '1') {
          setReminderAccordionState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
            visibleArea: 'calendar',
            isEmailBlockHidden: true
          }));
        }
        const [eventDateFull, eventDateToFull] = generateDateForCalendar(validEvents[0]);
        const newUrls = makeUrls({
          name: get(title, 'value'),
          details: get(introText, 'value'),
          location: get(venue, 'address.jss.value'),
          startsAt: `${eventDateFull}`,
          endsAt: `${eventDateToFull ? eventDateToFull : eventDateFull}`
        });
        setCurrentUrls(newUrls);
      }
      setEventForReminder(_objectSpread(_objectSpread({}, eventObjForReminder), {}, {
        detailEventDateStart: validEvents[0].Date,
        detailEventDateEnd: validEvents[0].DateTo,
        numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd
      }));
    } else {
      (reminderQueryParamValue === '1' || reminderQueryParamValue === '2' || reminderPopupVisible) && setactivateEvents('show-events');
    }
  }, [reminderQueryParamValue, reminderPopupVisible]);
  const currentDateFormatted = (() => {
    const currentDate = new Date(new Date().getTime());
    currentDate.setUTCHours(0, 0, 0, 0);
    return currentDate;
  })();
  let numberOfDaysBeforeEventEnd;
  if (validEvents.length === 1) {
    const eventDateTo = validEvents[0].DateTo;
    const eventDate = validEvents[0].Date;
    numberOfDaysBeforeEventEnd = differenceInDays(new Date(eventDateTo ? eventDateTo : eventDate), currentDateFormatted);
  }
  useEffect(() => {}, [reminderAccordionState, calendarReminderState, eventForReminder]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isSharedCh: isSharedCh,
    style: colorVariables
  }, /*#__PURE__*/React.createElement(StickyCtaAssistant, null), showPopup ? /*#__PURE__*/React.createElement(EventPopup, {
    heading: dictionaries.get('expiration header'),
    copy: dictionaries.get('expiration copy'),
    ctaLabel: dictionaries.get('expiration cta'),
    ctaLink: redirectURL
  }) : null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: `
        {
          "@context": "https://schema.org",
          "@type": "Event",
          "name": "${get(fields, 'data.item.title.jss.value', '').replace(/"/g, "'")}",
          "startDate": "${eventStartDate}",
          "endDate": "${eventEndDate}",
          "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
          "eventStatus": "https://schema.org/EventScheduled",
          "location": {
            "@type": "Place",
            "name": "${locationSchema && locationSchema.replace(/"/g, "'")}",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "${locationaddressSchema && locationaddressSchema.replace(/"/g, "'")}"
            }
          },
          "url": "${canUseDOM ? window.location.href : ''}",

          "description": ${JSON.stringify(get(fields, 'data.item.introText.jss.value'))}

        }`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${isSharedCh ? '' : 'module-group'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events"
  }, /*#__PURE__*/React.createElement("div", {
    className: `row ${isSharedCh ? 'header-events-wrapper' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-lg-7 col-xl-7"
  }, isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "fav-btn-box fav-btn-box--shared"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    isSharedCh: isSharedCh,
    classes: ' header-events__fav-btn my-icon-white d-md-inline-block',
    analyticsClick: action => {
      tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${name}`);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "header-events__featured-image-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events__mobileThemeLogo"
  }, theme && theme.dubai_calendar_logo && /*#__PURE__*/React.createElement("img", {
    className: "",
    src: BASE_URL + theme.dubai_calendar_logo + '?cx=0.5&cy=0.5&cw=125',
    alt: "Logo"
  })), process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder(), !isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "fav-btn-box"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: ' header-events__fav-btn my-icon-white d-md-inline-block',
    analyticsClick: action => {
      tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${name}`);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 col-lg-5 col-xl-5",
    ref: carouselBlockRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events__info"
  }, isSharedCh ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "header-events__label"
  }, tagName), renderCurators(), renderLogo()) : /*#__PURE__*/React.createElement(React.Fragment, null, renderCurators(), renderLogo(), /*#__PURE__*/React.createElement("div", {
    className: "header-events__label"
  }, tagName)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "scroll-action-btn",
    ref: buttonRef,
    onClick: () => {
      scrollRef.current && scrollRef.current.scrollToRight();
    }
  }, "scroll")), /*#__PURE__*/React.createElement("div", {
    className: "row header-events__header-panel"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${isSharedCh ? 'col-12' : ''}`
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: "header-events__title",
    tag: "h1",
    field: title
  }), introText && /*#__PURE__*/React.createElement(Text, {
    className: "body-small header-events__desc",
    tag: "p",
    field: introText
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  })), validEvents.length >= 1 && /*#__PURE__*/React.createElement("div", {
    className: `header-events__wrapper-list ${hideEvents ? 'header-events__wrapper-list--hidden' : ''} valid-events--${validEvents.length}`
  }, /*#__PURE__*/React.createElement(Scrollbars, {
    className: "scrollbar",
    ref: scrollRef,
    thumbMinSize: 179,
    thumbSize: 290,
    autoHeight: true,
    renderThumbHorizontal: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
      className: "thumb-horizontal"
    })),
    renderTrackHorizontal: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
      className: "track-horizontal"
    })),
    style: {
      width: '100%',
      height: isSharedCh ? 155 : 110
    },
    onScrollStart: () => tealiumClickFunc(tealiumMergeClickData(sliderAnalytics, params), name)
  }, /*#__PURE__*/React.createElement("div", {
    className: `header-events__scroller2 header-events-length--${validEvents.length}`,
    onScroll: () => {
      tealiumClickFunc(tealiumMergeClickData(sliderAnalytics, params), `${dictionaries.get('SeeAllDates')} : ${name}`);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: `header-events__scroller-inner`
  }, renderEventDates(2, validEvents, venue), validEvents.length > 2 && /*#__PURE__*/React.createElement("div", {
    className: "header-events__see-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    className: "header-events__see-all",
    "aria-label": "See All Dates",
    onClick: e => {
      tealiumClickFunc(tealiumMergeClickData(seeAllDatesClickAnalytics, params), `${dictionaries.get('SeeAllDates')} : ${name}`);
      showEvents(e);
    },
    href: "/"
  }, /*#__PURE__*/React.createElement("span", null, dictionaries.get('SeeAllDates')), /*#__PURE__*/React.createElement(ChevronRightLight, {
    className: "header-events__chevron-icon news__more-icon"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "header-events__info-box"
  }, !defaultAddress ? /*#__PURE__*/React.createElement(React.Fragment, null, (venueValues.length >= 1 || googlePlaceIDCollection.length >= 1) && showLocationIcon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `info-box-list info-box-list__top ${locationIcon}`
  }, showLocationIcon && /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__icon"
  }, /*#__PURE__*/React.createElement(LocationBlue, {
    className: "info-box-list__img location"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__item"
  }, (() => {
    if (googlePlaceIDCollection.length === 1 && venueValues.length === 0) return renderPlaceIdLink();else if (googlePlaceIDCollection.length === 0 && venueValues.length === 1) return renderVenuesLink(locationAnalytics, params, name);else return renderVariousLocationsLink(locationAnalytics, params, name);
  })())))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `info-box-list info-box-list__top ${locationIcon}`
  }, showLocationIcon && /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__icon"
  }, /*#__PURE__*/React.createElement(LocationBlue, {
    className: "info-box-list__img location"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__item"
  }, defaultAddress))), (isFree || minPrice || minPrice || ticketPrice || ticketsAvailable) && /*#__PURE__*/React.createElement("div", {
    className: "info-box-list info-box-list--price"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__icon"
  }, /*#__PURE__*/React.createElement(Ticket, {
    className: "info-box-list__img"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__item"
  }, /*#__PURE__*/React.createElement("p", {
    className: "info-box-list__content"
  }, renderPriceBlock())))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col static-on-mobile d-flex"
  }, tickets.length ? /*#__PURE__*/React.createElement("div", {
    className: "button-links-box"
  }, /*#__PURE__*/React.createElement("button", {
    className: "tickets-cta btn btn-primary",
    onClick: ticketsBtnClickHandler
  }, /*#__PURE__*/React.createElement("div", {
    className: "tickets-cta__title"
  }, dictionaries.get('BuyTickets')), /*#__PURE__*/React.createElement("div", {
    className: "tickets-cta__price"
  }, `
                                    ${dictionaries.get('AED')} ${minPrice || 0} - ${maxPrice || 0}
                                  `), /*#__PURE__*/React.createElement("span", {
    className: "tickets-cta__arrow"
  }, /*#__PURE__*/React.createElement(ChevronUp, {
    width: 28,
    height: 28
  }))), /*#__PURE__*/React.createElement("div", {
    className: `
                                tickets-cta-dd
                                ${ticketsDdVisible ? 'tickets-cta-dd--visible' : ''}
                              `
  }, /*#__PURE__*/React.createElement("ul", {
    className: "tickets-cta-dd__list"
  }, tickets[0].ticket.map((ticket, index) => /*#__PURE__*/React.createElement("li", {
    key: `${ticket.ticketSeller.jss.value}-${index}`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "tickets-cta-dd__seller"
  }, ticket.ticketSeller.jss.value), /*#__PURE__*/React.createElement("p", {
    className: "tickets-cta-dd__price-range"
  }, ticket.printPrice.jss.value)), renderBuyButton(ticket)))))) : (buyLink || buyLinkMobile || venueWebsite) && /*#__PURE__*/React.createElement("div", {
    className: "button-links-box m-0 flex-grow-0"
  }, isChina && venueWebsite && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary btn-primary--large",
    href: createRouterLink(buyLink, accessToken, venueWebsite, isTicketing),
    onClick: () => {
      runExtendedAnalytics(name);
    },
    title: dictionaries.get('GoToEventDetailsWebsite'),
    isSharedCh: isSharedCh,
    ctaLeftIcon: primaryCtaLinkLeftIcon,
    ctaRightIcon: primaryCtaLinkRightIcon
  }, dictionaries.get('GoToEventDetailsWebsite')), !isChina && !buyLinkMobile && /*#__PURE__*/React.createElement(RouterLink, {
    isSharedCh: isSharedCh,
    ctaLeftIcon: primaryCtaLinkLeftIcon,
    ctaRightIcon: primaryCtaLinkRightIcon,
    className: "btn btn-primary btn-primary--large",
    href: createRouterLink(buyLink, accessToken, venueWebsite, isTicketing),
    onClick: () => {
      runExtendedAnalytics(name);
    },
    title: buyLink ? dictionaries.get('BuyTickets') : dictionaries.get('GoToEventDetailsWebsite')
  }, buyLink ? dictionaries.get('BuyTickets') : dictionaries.get('GoToEventDetailsWebsite')), !isChina && buyLink && buyLinkMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    isSharedCh: isSharedCh,
    ctaLeftIcon: primaryCtaLinkLeftIcon,
    ctaRightIcon: primaryCtaLinkRightIcon,
    className: "btn btn-primary btn-primary--large d-md-inline-block d-none",
    href: createRouterLink(buyLink, accessToken, venueWebsite, isTicketing),
    onClick: () => {
      runExtendedAnalytics(buyLink);
    },
    title: buyLink ? dictionaries.get('BuyTickets') : dictionaries.get('GoToEventDetailsWebsite')
  }, dictionaries.get('BuyTickets')), /*#__PURE__*/React.createElement(RouterLink, {
    isSharedCh: isSharedCh,
    ctaLeftIcon: primaryCtaLinkLeftIcon,
    ctaRightIcon: primaryCtaLinkRightIcon,
    className: "btn btn-primary btn-primary--large d-md-none",
    href: createRouterLink(buyLinkMobile, accessToken, venueWebsite, isTicketing),
    onClick: () => {
      runExtendedAnalytics(buyLink);
    },
    title: dictionaries.get('BuyTickets')
  }, dictionaries.get('BuyTickets')))), !isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "fav-btn-box"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: ' header-events__fav-btn my-icon-white d-md-inline-block',
    analyticsClick: action => {
      tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${name}`);
    }
  }))))))), validEvents.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: `events-overlay ${activateEvents}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "events-overlay__header"
  }, /*#__PURE__*/React.createElement("a", {
    className: "events-overlay__close-btn d-none d-md-block",
    onClick: e => closeEvents(e),
    href: "/"
  }, /*#__PURE__*/React.createElement("img", {
    className: "events-overlay__close-btn-img",
    src: closeWhite,
    alt: CloseRemonderAccordeon
  })), /*#__PURE__*/React.createElement("a", {
    className: "events-overlay__back-btn d-block d-md-none",
    onClick: e => closeEvents(e),
    href: "/"
  }, /*#__PURE__*/React.createElement("img", {
    className: "events-overlay__back-btn-img",
    src: arrowLeftnoborderWhite,
    alt: "back"
  }), /*#__PURE__*/React.createElement("span", null, dictionaries.get('back'))), title && /*#__PURE__*/React.createElement(Text, {
    className: "events-overlay__title h2",
    tag: "h3",
    field: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "events-overlay__scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events-overlay__list-wrapper"
  }, validEvents && validEvents.length && renderListDate()))), /*#__PURE__*/React.createElement("div", {
    className: clsx('reminder-accordion-overlay', {
      'reminder-accordion-overlay--visible': reminderAccordionState.visible
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('reminder-accordion-wrapper', {
      'reminder-accordion-wrapper--visible': reminderAccordionState.visible
    })
  }, /*#__PURE__*/React.createElement("h3", {
    className: clsx('reminder-accordion__header', {
      'reminder-accordion__header-fix': isOpenReminderCalendarPicker
    })
  }, setReminderLabel, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
        isEmailBlockHidden: false
      }));
      setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
        visible: false
      }));
    },
    className: "reminder-accordion__header-close btn--reset",
    "aria-label": CloseRemonderAccordeon
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list"
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx('reminder-accordion__list-opener btn--reset', {
      'reminder-accordion__list-opener--opened': reminderAccordionState.visibleArea === 'email',
      'btn--hidden': isOpenReminderCalendarPicker,
      'this-block--hidden': reminderAccordionState.isEmailBlockHidden
    }),
    onClick: () => {
      changeAccordeonArea('email');
    }
  }, emailReminderLabel, reminderAccordionState.visibleArea === 'email' ? /*#__PURE__*/React.createElement(MinusIcon, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(PlusIcon, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx('reminder-accordion__list-content', {
      'this-block--hidden': reminderAccordionState.isEmailBlockHidden
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('reminder-accordion__list-content-intro', {
      'btn--hidden': isOpenReminderCalendarPicker
    })
  }, /*#__PURE__*/React.createElement(EmailBigIcon, {
    className: "icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content-intro-text"
  }, accordeonIntroLabel)), /*#__PURE__*/React.createElement(Reminder, {
    userProfile: userProfile,
    lang: currentLang,
    event: eventForReminder,
    eventDetail: true,
    eventsAnalytics: eventsAnalytics,
    location: get(venue, 'title.jss.value'),
    countryItems: countryItems,
    hidableMode: false,
    params: params,
    externalSuccessCallback: () => {
      setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
        visible: false
      }));
    },
    reminderAccordionStateValue: reminderAccordionState.visibleArea,
    setIsOpenReminderCalendarPicker: setIsOpenReminderCalendarPicker,
    setReminderAccordionState: setReminderAccordionState,
    numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd,
    isSharedCh: isSharedCh
  })), /*#__PURE__*/React.createElement("button", {
    className: clsx('reminder-accordion__list-opener btn--reset', {
      'reminder-accordion__list-opener--opened': reminderAccordionState.visibleArea === 'calendar'
    }),
    onClick: () => {
      changeAccordeonArea('calendar');
      setIsOpenReminderCalendarPicker(false);
    }
  }, calendarReminderLabel, reminderAccordionState.visibleArea === 'calendar' ? /*#__PURE__*/React.createElement(MinusIcon, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(PlusIcon, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content-intro"
  }, /*#__PURE__*/React.createElement(CalendarBigIcon, {
    className: "icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content-intro-text"
  }, accordeonIntroLabel)), /*#__PURE__*/React.createElement("div", {
    className: "calendar-reminder-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx('calendar-reminder__dd-btn btn--reset', {
      'calendar-reminder__dd-btn--opened': calendarReminderState.visible
    }),
    onClick: () => {
      setCalendarReminderState(_objectSpread(_objectSpread({}, calendarReminderState), {}, {
        visible: true
      }));
      tealiumClickFunc(tealiumMergeClickData(addToCalendarClickAnalytics, params), name);
    }
  }, calendarReminderState.selectedString || selectMediaLabel, ' ', /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), calendarReminderState.visible && /*#__PURE__*/React.createElement("ul", {
    className: "calendar-reminder__dd-variants-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    disabled: true,
    className: "calendar-reminder__dd-variant btn--reset"
  }, selectMediaLabel)), !isChina && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'Google']);
      setCalendarReminderState({
        value: 'google',
        selectedString: 'Google',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderGoogle)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'Outlook Web App']);
      setCalendarReminderState({
        value: 'outlook',
        selectedString: 'Outlook Web App',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderOutlookWebApp)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'Outlook']);
      setCalendarReminderState({
        value: 'ics',
        selectedString: 'Outlook',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderOutlook)), !isChina && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'yahoo']);
      setCalendarReminderState({
        value: 'yahoo',
        selectedString: 'Yahoo',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderYahoo))), /*#__PURE__*/React.createElement("div", {
    className: "calendar-reminder__submit-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    href: currentUrls[calendarReminderState.value] || '#',
    target: "_blank",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailReminderInteractionAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), dictionaries.get('AddToCalendar'), calendarReminderState.value]);
    },
    "aria-label": `${dictionaries.get('AddToCalendar')} | ${newWindowLabel}`,
    rel: "noopener noreferrer",
    className: clsx('btn btn-primary', {
      'btn-disabled': !calendarReminderState.selectedString
    })
  }, dictionaries.get('AddToCalendar'))))))))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    isSharedCh,
    style
  } = _ref2;
  const commonStyles = isSharedCh ? "c10132if" : "c1cin5gz";
  const rtlStyles = isSharedCh ? "r1mk7ejx" : "r10mhlhg";
  const ltrStyles = isSharedCh ? "lbuxjmj" : "l1l03pmx";
  "s1yzush8";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    className: `
      ${addToCalendarDropdown}
      ${commonStyles}
      ${rtl ? rtlStyles : ltrStyles}
      ${headerImageStyle}
      ${scrollbarStyles}
      ${ticketstStyles}
      ${remindAccordionStyles}`
  }, children);
};
const addToCalendarDropdown = "asua8zh";
const scrollbarStyles = "ssxv8uy";
const ticketstStyles = "t1e13xka";
const remindAccordionStyles = "r1yftf1g";
export default EventHeader;